import React, { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { Trophy } from "lucide-react";
import { trophies } from "@/lib/trophies";

const TIER_COLORS = { bronze: "#B45309", silver: "#64748B", gold: "#D97706", platinum: "#0284C7" };

export default function TrophyToasts() {
  const [toasts, setToasts] = useState([]);

  useEffect(
    () =>
      trophies.subscribe((t) => {
        const item = { ...t, key: `${t.id}-${Date.now()}` };
        setToasts((q) => [...q, item]);
        setTimeout(() => setToasts((q) => q.filter((x) => x.key !== item.key)), 4200);
      }),
    []
  );

  return (
    <div className="pointer-events-none fixed right-4 top-20 z-[70] flex flex-col gap-3">
      <AnimatePresence>
        {toasts.map((t) => (
          <motion.div
            key={t.key}
            data-testid="trophy-toast"
            initial={{ x: 90, opacity: 0 }}
            animate={{ x: 0, opacity: 1 }}
            exit={{ x: 90, opacity: 0 }}
            transition={{ type: "spring", stiffness: 300, damping: 26 }}
            className="iv-glass flex items-center gap-3 rounded-xl px-4 py-3"
            style={{ borderLeft: `3px solid ${TIER_COLORS[t.tier]}` }}
          >
            <span
              className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full"
              style={{ background: `${TIER_COLORS[t.tier]}1A` }}
            >
              <Trophy size={16} color={TIER_COLORS[t.tier]} />
            </span>
            <span>
              <span className="block f-mono text-[8px] tracking-[0.3em] text-[#94A3B8]">
                TROPHY UNLOCKED · {t.tier.toUpperCase()}
              </span>
              <span className="block f-orbitron text-xs font-bold text-[#0F172A]">{t.name}</span>
              <span className="block text-[10px] text-[#64748B]">{t.desc}</span>
            </span>
          </motion.div>
        ))}
      </AnimatePresence>
    </div>
  );
}
